/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

export default {
  breakpoints: {
    'base': '0px',
    'xsm': '375px',
    'sm': '480px',
    'md': '768px',
    'lg': '992px',
    'slx': '1024px',
    'xl': '1280px',
    '2xl': '1536px',
  },
  devices: {
    mobile: {enter: 'base', leave: 'md'},
    tablet: {enter: 'md', leave: 'xl'},
    desktop: {enter: 'xl', leave: ''},
  },
};
